module.exports = __webpack_public_path__ + "static/img/ae9ad757a57e27b7(1).09947f32.png";